module.exports = __webpack_public_path__ + "static/media/indigena.ec385b16.svg";